import React from 'react';

const SuccessIcon = props => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 4C12.954 4 4 12.954 4 24C4 35.046 12.954 44 24 44C35.046 44 44 35.046 44 24C44 12.954 35.046 4 24 4Z"
      stroke="#1890ff"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M16 24L22 30L34 18"
      stroke="#1890ff"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SuccessIcon;
